module.exports = __webpack_public_path__ + "img/22.9c51c18b.jpg";